import React from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps'

const GoogleMapsBase = withScriptjs(withGoogleMap(({ showMarker, ...props }) => (
  <div>
    <GoogleMap
      defaultZoom={15}
      defaultCenter={{ lat: -33.419550, lng: -70.581820 }}
      {...props}
    >
      {showMarker && <Marker position={{ lat: -33.419550, lng: -70.581820 }} />}
    </GoogleMap>
  </div>
)))

export const GoogleMapsView = (props) => (
  <GoogleMapsBase
    googleMapURL='https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyBsoqT-TjRvaWLh_pXCMUn19LrQNylJgsw'
    loadingElement={<div style={{ height: `100%` }} />}
    containerElement={<div style={{ height: `200px` }} />}
    mapElement={<div style={{ height: `100%` }} />}
    {...props}
  />
)

export default GoogleMapsBase
